export const apiListCustomerContract = "/1.0/wsm/contract/customer/list"
export const apiCreateCustomerContract = "/1.0/wsm/contract/customer/create"
export const apiUpdateCustomerContract = id => `/1.0/wsm/contract/customer/${id}/update`
export const apiGetCustomerContractDetail = id => `/1.0/wsm/contract/customer/${id}/detail`
export const apiListCustomer = "/1.0/wsm/dropdownlist/customers"

export const apiListLeaderContract = "/1.0/wsm/leader/contract/list"